export default __webpack_public_path__ + "static/media/mobile_09.577414d0.png";